import React from "react";

export default function AvatarSvg({ initials }) {
  return (
    <svg width="60" height="60">
      <circle
        cx="30"
        cy="30"
        r="30"
        fill="silver"
      />

      <text
          fontWeight="bold"
          fontSize="14"
          x="50%"
          y="50%"
          textAnchor="middle"
          dy=".35em"
          fill="black"
      >
        {initials}
      </text>
    </svg>
  );
}